<div class="d-flex align-items-center gap-3"
     [class.questionnaire-field-spacer]="!props.disableBottomMargin"
     [class.small-bottom-spacing]="props.smallBottomSpacing">
    <p-checkbox class="d-flex align-items-center" id="checkbox" name="checkbox" [formControl]="formControl" [binary]="true" />
    <label for="checkbox" *ngIf="props.checkboxLabel">
        {{props.checkboxLabel}}
    </label>
    <p class="secondary-label" *ngIf="props.secondaryLabel">
        {{props.secondaryLabel}}
    </p>
</div>
<formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
